import React, { useEffect, useState } from 'react';
import "./SpecialistForm.scss"

import { dateFromDDMMYYYYtoYYYYMMDD } from '../../../../helpers/datetime';
import Input from '../../../UI/Input/Input';
import Textarea from '../../../UI/Textarea/Textarea';

import SpecialistFormClinics from "../SpecialistFormClinics/SpecialistFormClinics";
import SpecialistFormPositions from "../SpecialistFormPositions/SpecialistFormPositions";
import SpecialistFormHours from "../SpecialistFormHours/SpecialistFormHours";
import SpecialistFormDays from "../SpecialistFormDays/SpecialistFormDays";

import PostService from '../../../../API/PostService';
import { useFetching } from '../../../../hooks/useFetching';
import { setSpecialistsAction } from '../../../../store/scheduleReducer';
import { useSelector, useDispatch } from 'react-redux';
import { timeToSeconds } from '../../../../helpers/datetime';
import { useNavigate } from 'react-router-dom';

const SpecialistForm = ({ id = null, specialist = null }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clinic = useSelector(state => state.schedule.clinic);
    const period = useSelector(state => state.schedule.period);
    const currensSchedule = useSelector(state => state.schedule.currensSchedule);

    const [canEdit, setCanEdit] = useState(false);
    const [edited, setEdited] = useState(false);

    const [totalWorkersTime, setTotalworkersTime] = useState();

    const [config, setConfig] = useState({
        worker_id: id,
        sites: specialist.site_id ? specialist.site_id : [],
        positions: specialist.position_id ? specialist.position_id : [],
        working_days_interval: specialist.preferences.working_days_interval ? specialist.preferences.working_days_interval : '',
        rest_days_interval: specialist.preferences.rest_days_interval ? specialist.preferences.rest_days_interval : '',
        is_personal_hours: specialist.preferences.is_personal_hours ? 1 : 0,
        working_days_list: specialist.preferences.working_days_list ? specialist.preferences.working_days_list : [],
        personal_working_hours_start: specialist.preferences.personal_working_hours_start ? specialist.preferences.personal_working_hours_start : 36000,
        personal_working_hours_end: specialist.preferences.personal_working_hours_end ? specialist.preferences.personal_working_hours_end : 79200,
        working_hours_monthly_max: specialist.preferences.working_hours_monthly_max ? specialist.preferences.working_hours_monthly_max : "",
        leaves: specialist.preferences.leaves ? specialist.preferences.leaves : "",
    });
    const [enableFinish, setEnableFinish] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        setTimeout(() => {
            setCanEdit(true)
        }, 500);

        fetchTotalWorkersTime();
    }, [])

    const selectedHandlerClinics = (ids) => {
        let newConfig = { ...config, sites: ids }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const selectedHandlerPositions = (ids) => {
        let newConfig;

        if (Array.isArray(ids)) {
            newConfig = { ...config, positions: ids }
        } else {
            newConfig = { ...config, positions: [ids] }
        }

        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const recieveWorkingDays = (value) => {
        let newConfig = { ...config, working_days_interval: value.work, rest_days_interval: value.rest, working_days_list: value.days }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const recieveMonthlyHours = (value) => {
        let newConfig = { ...config, working_hours_monthly_max: value }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const recieveLeavesValue = (value) => {
        let newConfig = { ...config, leaves: value }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const selectedHoursType = (value) => {
        let newConfig = { ...config, is_personal_hours: value }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const selectedHoursStart = (value) => {
        const seconds = timeToSeconds(value);
        let newConfig = { ...config, personal_working_hours_start: seconds }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const selectedHoursEnd = (value) => {
        const seconds = timeToSeconds(value.time);
        let newConfig = { ...config, personal_working_hours_end: seconds }
        checkEnableFinish(newConfig, config)
        setConfig(newConfig)
    }

    const checkEnableFinish = (config, oldConfig) => {
        if ((JSON.stringify(config) !== JSON.stringify(oldConfig)) && canEdit) {
            setEdited(true)
        }

        let enable = true;
        const newErrors = {};

        if (config.positions.length === 0 || config.positions === null) {
            enable = false;
            newErrors.positions = 'Не выбрана роль специалиста';
        }

        if (config.sites.length === 0 || config.sites === null) {
            enable = false;
            newErrors.sites = 'Не выбран салон';
        }

        if (((config.rest_days_interval === '' || config.working_days_interval === '') && config.working_days_list.length === 0)) {
            enable = false;
            newErrors.working_days = 'Не выбраны рабочие дни';
        }

        if (config.working_hours_monthly_max === '' || config.working_hours_monthly_max === null || config.working_hours_monthly_max <= 0) {
            enable = false;
            newErrors.working_hours_monthly_max = 'Не заполнено количество рабочих часов';
        }

        if (config.is_personal_hours === '' || config.is_personal_hours === null) {
            enable = false;
            newErrors.is_personal_hours = 'Не выбран тип расписания';
        }

        setErrorMessage(newErrors);
        setEnableFinish(enable);

        if (Object.keys(newErrors).length === 0) {
            setClicked(false);
        }
    }

    const [fetchSpecialists] = useFetching(async () => {
        const response = await PostService.getWorkers()
        
        if (response.data.success && response.data.result !== false) {
            
            const specialistArray = response.data.result.map((specialist, index) => {
                return {
                    ...specialist,
                    total_hours: totalWorkersTime && totalWorkersTime[specialist.id] ? totalWorkersTime[specialist.id] : 0,
                    orderIndex: index,
                }
            })

            dispatch(setSpecialistsAction(specialistArray))
        }
    })

    const [fetchTotalWorkersTime] = useFetching(async () => {
        const response = await PostService.getTotalWorkerTime(currensSchedule);

        if (response.data.success && response.data.result !== false) {
            setTotalworkersTime(response.data.result)
        }
    })

    const saveChanges = () => {
        if (edited && !enableFinish) {
            setClicked(true);
        } else if (edited && enableFinish) {
            fetchUpdateSpecialist(config);
        }
    }

    const [fetchUpdateSpecialist] = useFetching(async (data) => {
        const response = await PostService.editSpecialistPreferences(data)

        if (response.data.success && response.data.result !== false) {
            fetchSpecialists()
            navigate('/schedule/');
        }
    })

    return (
        <div className="specialist-form">
            <div className="specialist-form__headline">
                <h3><span>{specialist.orderIndex + 1}. </span>{specialist?.name}, <span className='specialist-form__position'>{specialist?.position_id && specialist?.positions && specialist.positions[specialist.position_id[0]] ? specialist.positions[specialist.position_id[0]].name : 'сотрудник'}</span></h3>
            </div>
            <SpecialistFormPositions
                selectHandler={selectedHandlerPositions}
                selectedPosition={specialist.position_id ? specialist.position_id : null}
                errorMessage={errorMessage?.positions && clicked ? errorMessage.positions : ''}
            />
            <SpecialistFormClinics
                selectClinicHandler={selectedHandlerClinics}
                selectedClinic={specialist.preferences?.site_priorities ? specialist.preferences.site_priorities : null}
                defaultClinicItem={specialist.site ? specialist.site : null}
                errorMessage={errorMessage?.sites && clicked ? errorMessage.sites : ''}
            />
            <SpecialistFormDays
                recieveWorkingDays={recieveWorkingDays}
                workInterval={specialist?.preferences?.working_days_interval ? specialist.preferences.working_days_interval : ''}
                restInterval={specialist?.preferences?.rest_days_interval ? specialist.preferences.rest_days_interval : ''}
                workingDaysList={specialist?.preferences?.working_days_list ? specialist.preferences.working_days_list : []}
                errorMessage={errorMessage?.working_days && clicked ? errorMessage.working_days : ''}
            />
            <SpecialistFormHours
                selectedHoursType={selectedHoursType}
                selectedHoursStart={selectedHoursStart}
                selectedHoursEnd={selectedHoursEnd}
                selectedType={specialist?.preferences?.is_personal_hours ? specialist.preferences.is_personal_hours : false} hoursStart={specialist?.preferences?.personal_working_hours_start ? specialist.preferences.personal_working_hours_start : ''}
                hoursEnd={specialist?.preferences?.personal_working_hours_end ? specialist.preferences.personal_working_hours_end : ''}
                errorMessage={errorMessage?.is_personal_hours && clicked ? errorMessage.is_personal_hours : ''} />
            <div className="specialist-form__input-monthly-hours">
                <Input
                    label='Максимальное кол-во рабочих часов в месяце'
                    inputHandler={recieveMonthlyHours}
                    type='monthly_hours'
                    defaultValue={specialist?.preferences?.working_hours_monthly_max ? specialist.preferences.working_hours_monthly_max : ''}
                    errorMessage={errorMessage?.working_hours_monthly_max && clicked ? errorMessage.working_hours_monthly_max : ''} />
            </div>
            <div className="specialist-form__leaves">
                <span className='specialist-form__leaves-title'>Ближайшие отсутствия</span>
                <div className="specialist-form__leaves-textarea">
                    <Textarea
                        placeholder=''
                        isLeaves={true}
                        onChange={recieveLeavesValue}
                        defaultValue={specialist ? specialist?.leaves : ''}
                        defaultHeight={96} />
                </div>
            </div>
            <div className="specialist-form__submit">
                <button className={!edited || !enableFinish ? 'g-button disabled' : 'g-button'} onClick={saveChanges}>Сохранить</button>
            </div>
        </div>
    );
};

export default SpecialistForm;